import { AppData, Lightning } from "@lightningjs/sdk";
import { Helper } from "../lib/helper";
import { AppSetup } from "../lib/app-setup";
import { AppApiConfig } from "../../dist/build-ts/lib/app-api-config";

const btnBgColor = 0xffffffff;
const textBgColor = 0xFF000000;

export default class LableButton extends Lightning.Component {
    _action: any;
    _label: string = "";

    static override _template() {
        return {
            w: (w: any) => w,
            h: (h: any) => h,
            y: 10,
            rect: true,
            color: btnBgColor,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 4 },
            Label: {
                x: (w: any) => w / 2,
                y: (h: any) => h / 2 + 5,
                mount: 0.5,
                text: {
                    text: '',
                    fontSize: 26,
                }
            }
        };
    }

    set label(v: any) {
        if (this._label === v) return;
        this._label = v;
        if (this.tag('Label')) {
            this.tag('Label').text.text = v.toUpperCase();
        }
    }

    set action(v: any) {
        this._action = v;
    }

    get action() {
        return this._action;
    }


    override _init() {
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        this.textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor)
    }

    override _handleEnter() {
        if (this._action) {
            this.fireAncestors(this._action);
        }
        return true;
    }

    override _handleClick() {
        if (this._action) {
            this.fireAncestors('$onButtonClick', this);
            this.fireAncestors(this._action);
        }
        return true;
    }

    override _focus() {
        this.color = this.textfocuscolor;
        this.tag('Label').text.textColor = btnBgColor;
    }

    override _unfocus() {
        this.color = btnBgColor;
        this.tag('Label').text.textColor = textBgColor;
    }
}
